export default __webpack_public_path__ + "static/media/ic-operation.d0fe6cbb.svg";